import {createReducer, on} from '@ngrx/store';
import {BeleguebersichtState} from '../../interfaces/beleguebersicht-state.interface';
import {BeleguebersichtActions} from '../actions/beleguebersicht.actions';


export const initialBeleguebersichtState: BeleguebersichtState = {
  verfuegbareFirmaIds: [],
  verfuegbarkeitLoaded: false,
  url: undefined,
  loading: false,
  error: false,
};

export const beleguebersichtReducer = createReducer(
  initialBeleguebersichtState,

  on(BeleguebersichtActions.verfuegbarkeitLoaded,
    (state, action) => ({
      ...state,
      verfuegbareFirmaIds: action.firmaIds,
      verfuegbarkeitLoaded: true,
    })),

  on(BeleguebersichtActions.loadVerfuegbarkeitFailure,
    (state) => ({
      ...state,
      verfuegbareFirmaIds: [],
      verfuegbarkeitLoaded: true,
    })),

  on(BeleguebersichtActions.loadUrl,
    (state) => ({
      ...state,
      loading: true,
      error: false,
      url: undefined,
    })),

  on(BeleguebersichtActions.urlLoaded,
    (state, action) => ({
      ...state,
      loading: false,
      url: action.url,
    })),

  on(BeleguebersichtActions.loadUrlFailure,
    (state) => ({
      ...state,
      loading: false,
      error: true,
      url: undefined,
    })),

  on(BeleguebersichtActions.urlCleared,
    (state) => ({
      ...state,
      url: undefined,
      loading: false,
      error: false,
    })),
);
